import { createRouter, createWebHistory } from "vue-router";
import roles from "../utils/roles";
import store from "../store/index.js";

import { homeRouters } from "./routers/home.js";
import { infoRouters } from "./routers/info.js";
import { userRouters } from "./routers/users.js";
import { schemaRouters } from "./routers/schema.js";
import { errorRouters } from "./routers/error.js";
import { contactsRouters } from "./routers/contacts.js"
import { adminRouters } from "./routers/admin.js"
import { tasksRouters } from "./routers/tasks.js"
import { kanbanRouters } from "./routers/kanban.js"
import { calendarRouters } from "./routers/calendar.js"
import { booksRouters } from "./routers/books.js" 
import { librariesRouters } from "./routers/libraries.js" 
import { schoolsRouters } from "./routers/schools.js" 
import { studentsRouters } from "./routers/students.js" 
import { library_booksRouters } from "./routers/library_books.js" 
import { book_loansRouters } from "./routers/book_loans.js" 
import { library_settingsRouters } from "./routers/library_settings.js" 
import { reportsRouters } from "./routers/reports.js" 
//import

const router = createRouter({ 
    routes: [
        ...homeRouters,
        ...library_settingsRouters,
        ...book_loansRouters,
        ...library_booksRouters,
        ...studentsRouters,
        ...schoolsRouters,
        ...librariesRouters,
        ...booksRouters,
        ...reportsRouters,
        ...contactsRouters,
        ...infoRouters,
        ...userRouters,
        ...schemaRouters,
        ...adminRouters,
        ...tasksRouters,
        ...kanbanRouters,
        ...calendarRouters,
        ...errorRouters,
        {
            path: '/admin/migration',
            name: 'AdminMigration',
            component: () => import('../views/admin/Settings.vue'),
            meta: {
                requiresAuth: true,
                title: 'Database Migration'
            }
        }
    ],

    // use url #
    //history: createWebHashHistory() 
    history: createWebHistory()

})

router.beforeEach((to, from, next) => {
  const role = store.getters._getCurrentRole || 1;
  const isAuth = store.getters._isAuthenticated || false;
  const user = store.getters._getCurrentUser;



  if(isAuth){
    
    if([2,3].includes(role)){
      if((!user?.school_id ||user?.school_id == "") && to.name != "SchoolsList"){
        next({ name: "SchoolsList" });
        return;
      }
  
      if((!user?.library_id || user?.library_id == "") && user?.school_id != ""  && to.name != "LibrariesList"){
          next({ name: "LibrariesList" });
          return;
      }
  
   
        // Special case for homepage
      if(to.name == "HomePage"){  
        next({ name: "Book_loansHome" });
        return;
      }
    }else if([4].includes(role)){
      if(to.name == "HomePage"){  
        next({ name: "StudentsDetailShort", params: { id: user?.student_id } });
        return;
      }
    }
  }



  // Check if the route exists in our role definitions
  if (!roles[to.name]) {
    next({ name: "Error404" });
    return;
  }

  // Check if the user has permission to access this route
  if (!roles[to.name].includes(role)) {
    next({ name: "ErrorPage" });
    return;
  }

  // School Manager role specific restrictions (role 2)
  if (role === 2 && to.params && to.params.id) {
    // Check if the resource belongs to the school manager's school
    // This would need actual implementation based on your data model
    // For example, checking if the library_id or school_id matches the manager's school
    
    // For now, we'll just pass it through
    next();
    return;
  }

  // Student role specific restrictions (role 3)
  if (role === 3 && to.name.includes('Book_loans') && to.params && to.params.id) {
    // Check if the book loan belongs to the student
    // This would need actual implementation based on your data model
    
    // For now, we'll just pass it through
    next();
    return;
  }


  // If all checks pass, allow navigation
  next();
});

export default router;
